import PhoneButton from '../Button/PhoneButton';

export default function CustomizePackageCallToAction() {
  return (
    <div className="bg-gray-100">
      <div className="px-8 py-8 mx-auto max-w-7xl sm:py-16 sm:px-6 lg:px-16">
        <div className="text-center">
          {/* <h2 className="text-base font-semibold tracking-wide uppercase text-primary-600">
            Pricing
          </h2> */}
          <p className="mt-1 text-3xl font-bold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-4xl">
            <span className="block mb-8 md:inline md:mb-0">
              Customize your home energy package.
            </span>
            <PhoneButton size="xl" className="px-12 ml-0 border-2 md:ml-16" />
          </p>
          {/* <p className="max-w-xl mx-auto mt-5 text-xl text-gray-500">
            Start building for free, then add a site plan to go live. Account
            plans unlock additional features.
          </p> */}
        </div>
      </div>
    </div>
  );
}
